import React, { Component } from 'react';

import Row from './row';
import ExpandedOfferRow from './expanded-offer-row';
import ExpandedAffiliateRow from './expanded-affiliate-row';
import Pagination from '../../../shared/pagination';

import './main.less';

const Table = props => {

	const { table, intl, pagination, gotoPage, hideHiddenCells, showHiddenCells }  = props;

	return (
		<div
			className="table-container top-countries-table"
			onMouseDown={hideHiddenCells}
			onMouseUp={showHiddenCells}
		>
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium">
					<tr className="top-affiliates-table-top-row">
						{
							table.headers
								.map((header, i) =>
									<th key={i} className={header.className || ''}>{intl(header.title)}</th>
								)
						}
						{table.intervals.map((header, i) =>
							<th key={i} className='text-center'>{intl(header)}</th>
						)}
						<th className='text-center'>Total</th>
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{table.rows.map((row, i) => {
						if (row.affiliate_id) {
							return <ExpandedAffiliateRow
								{...props} key={i} row={row} intervals={table.intervals}
							/>;
						}
						if (row.offer_title) {
							return <ExpandedOfferRow
								{...props} key={i} row={row} intervals={table.intervals}
							/>;
						}
						return <Row
							key={i} {...props} row={row} intervals={table.intervals}
						/>;
					})}
				</tbody>
			</table>
			<p className="flex-center pagination-container">
				<Pagination pagination={pagination} gotoPage={gotoPage} />
			</p>
		</div>
	);
};

class TableContainer extends Component {
	constructor(props) {

		super(props);
		this.state = { isHiddenCells: false };
		this.hideHiddenCells = this.hideHiddenCells.bind(this);
		this.showHiddenCells = this.showHiddenCells.bind(this);
	}
	showHiddenCells () {
		window.is_debouncing = null;
		setTimeout(() => {
			this.setState({ isHiddenCells: false });
		}, 500);
	}
	hideHiddenCells () {
		window.is_debouncing = true;
		setTimeout(() => {
			window.is_debouncing && this.setState({ isHiddenCells: true });
		}, 500);
	}
	render() {
		return <Table
			{...this.props}
			isHiddenCells={this.state.isHiddenCells}
			showHiddenCells={this.showHiddenCells}
			hideHiddenCells={this.hideHiddenCells}
		/>;
	}
}

export default TableContainer;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-countries/components/table/main.js